import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/qrcode/img_qr_code.jpg'
import _imports_1 from '@/assets/img_wx.png'


const _withScopeId = n => (_pushScopeId("data-v-08b2c3c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qc-div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qc-content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "contact-qr-code-icon margin-top-30 margin-bottom-20"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "qc-content-title margin-bottom-30" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      class: "qc-content-title-icon"
    }),
    /*#__PURE__*/_createElementVNode("span", { class: "margin-left-15" }, "微信扫码，免费咨询")
  ])
], -1))

import {isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'QrCodeDialog',
  setup(__props) {

const onClick = () => {
  isShowQrCodeDialog.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _unref(isShowQrCodeDialog),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isShowQrCodeDialog) ? (isShowQrCodeDialog).value = $event : null)),
      width: "300",
      center: "",
      "custom-class": "dialog-without-scrollbar"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})